module.exports = __webpack_public_path__ + "img/CHUQUISACA.20cddfb8.png";